import React from "react";
import Tooltip, { TooltipProps } from "@material-ui/core/Tooltip";

function ConditionalTooltip({
  condition,
  children,
  wrap,
  ...props
}: { condition: boolean; wrap?: boolean } & TooltipProps) {
  if (condition) {
    if (wrap) children = <div>{children}</div>;
    return <Tooltip {...props}>{children}</Tooltip>;
  }
  return children;
}

export default ConditionalTooltip;
